import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";
import { Location } from "@App/Pages/Common/Location";
import { useServiceFunnel } from "@App/hooks/useServiceFunnel";

/**
 * The funnel for the "air conditioning" service.
 *
 * @constructor
 */
export const AirConditioning: FunctionComponent = () => {
  const { navigateWithQuery } = useServiceFunnel("klimaservice-klimaanlage-befuellen");

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Location
            headline={"Jetzt ganz einfach Klimaservice in deiner Nähe finden"}
            subheadline={"Wo suchst du eine Werkstatt?"}
            step={1}
            maxSteps={9}
            onSubmit={() => navigateWithQuery(`werkstaetten`)}
          />
        }
      />
    </Routes>
  );
};
